import type { ValidationTranslation } from './validation.translation.pl.ts';

export const validationTranslation: ValidationTranslation = {
  general: {
    required: 'Ce champ est obligatoire',
    maxLength: 'La longueur maximale est de {{max}} caractères',
  },
  phoneNumber: {
    format: 'Le numéro de téléphone doit comporter de 9 à 15 chiffres',
  },
  url: {
    format: 'Le lien doit commencer par https://',
  },
};
